const boxes = document.querySelectorAll(".box_container");
const inputs = document.querySelectorAll(".variant-input_container");
const addToCartBtn = document.querySelector("#addToCartBtn");
const subscriptionInputs = document.querySelectorAll(".purchase-options input");
let quantity =  document.querySelector(".box_container[data-selected='true']")?.dataset.value;
function setBox(e){
    boxes.forEach(box => box.dataset.selected = "false")
    const target =  e.target.closest(".box_container")
    target.dataset.selected = "true";
    renderInputs(parseInt(target.dataset.value));
    quantity = parseInt(target.dataset.value);
}

function renderInputs(amount){
    inputs.forEach((input,i) =>{
        if(i > amount - 1){
            input.style.display = "none"
        }else{
            input.style.display = "flex"
        }
    })
}
function getSelectedFreeQty(){
    const sel = document.querySelector(".box_container[data-selected='true']");
    return sel ? (parseInt(sel.dataset.freeQty, 10) || 0) : 0;
}
function makeProductsPlayload(selling_plan){
    const playload = {
        items:[]
    }
    const paidVariantIds = [];

    inputs.forEach((input,i) =>{
        if(i > quantity - 1){
            return
        }
        const id = input.querySelector(".selected-variant").dataset.selected_id
        paidVariantIds.push(id);
        const item = {
          id,
          quantity: 1,
          ...(selling_plan ? { selling_plan } : {})
        };

        playload.items.push(item);
    })
    // BOGO free units: Appstle BXGY prices them $0 at checkout. Free flavors cycle through the
    // paid picks. One-time purchases only (on subscription the free units must not be added).
    // Enabled per-product via .boxes_block[data-bogo-free] (set in main-product.liquid).
    // Excluded for 3+1 promo (different Appstle logic there — free unit handled another way).
    const BOGO_FREE_UNITS_ENABLED = (document.querySelector('.boxes_block')?.dataset.bogoFree === 'true');
    if(BOGO_FREE_UNITS_ENABLED && !selling_plan && paidVariantIds.length){
        const freeQty = getSelectedFreeQty();
        for(let f=0; f<freeQty; f++){
            playload.items.push({ id: paidVariantIds[f % paidVariantIds.length], quantity: 1 });
        }
    }
    return playload
}
async function addSelectedProducts(products) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(products)
      });

      if (!response.ok) {
        throw new Error('Failed to add items to cart');
      }

      const addData = await response.json();
      const cartResponse = await fetch('/cart.js');
      if (!cartResponse.ok) {
        throw new Error('Failed to retrieve shopping cart data');
      }
if (typeof window.monster_refresh === 'function') { window.monster_refresh(true); } else { window.location.href = '/cart'; }

    } catch (error) {
      console.error('Ошибка:', error);
      alert('Error adding products');
    }
  }

function getSellingPlan(){
  if(subscriptionInputs){
    const selectedInput = [...subscriptionInputs].find(input => input.checked);
    if(!selectedInput) return
    if(selectedInput.id === "one-time") return
    
    const selling_plan = document.querySelector(".selected-subscription").dataset.selected_id
    return selling_plan;
  }
}

if (boxes){
document.querySelectorAll('.variant-dropdown').forEach(select => {
    const selected = select.querySelector('.selected-variant');
    const selectedText = select.querySelector('.selected-variant span');
    const options = select.querySelector('.variants_options');
    
    selected.addEventListener('click', () => {
      const isOpen = select.getAttribute('data-open') === 'true';
      select.setAttribute('data-open', !isOpen);
    });
    
    options.querySelectorAll('.product-variant').forEach(option => {
      option.addEventListener('click', () => {
        selectedText.textContent = option.textContent;
        selected.dataset.selected_id = option.dataset.id
        select.setAttribute('data-open', 'false');
      });
    });
    
    document.addEventListener('click', (e) => {
      if (!select.contains(e.target)) {
        select.setAttribute('data-open', 'false');
      }
    });
  });
  const selectPlanDropdown = document.querySelector(".subscriptions_dropdown_container")
  if(selectPlanDropdown){
    const selectedPlan = selectPlanDropdown.querySelector('.selected-subscription');
    const selectedPlanText = selectPlanDropdown.querySelector('.selected-subscription span');
    const optionsPlan = selectPlanDropdown.querySelector('.subscription_options');
    
    selectPlanDropdown.addEventListener('click', () => {
      const isOpen = selectPlanDropdown.getAttribute('data-open') === 'true';
      selectPlanDropdown.setAttribute('data-open', !isOpen);
    });
    
    optionsPlan.querySelectorAll('.product-subscription').forEach(option => {
      option.addEventListener('click', (e) => {
        e.stopPropagation();
        selectedPlanText.textContent = option.textContent;
        selectedPlan.dataset.selected_id = option.dataset.id
        selectPlanDropdown.setAttribute('data-open', 'false');
      });
    });
    
    document.addEventListener('click', (e) => {
      if (!selectPlanDropdown.contains(e.target)) {
        selectPlanDropdown.setAttribute('data-open', 'false');
      }
    });
  }
boxes.forEach(box => box.addEventListener("click",setBox))
addToCartBtn.addEventListener("click",async () => {
    const playload = makeProductsPlayload(getSellingPlan());
    await addSelectedProducts(playload)
})
renderInputs(quantity)
}
